import { useContext, useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { SidebarContext } from "context/SidebarContext";
import TripadvanceServices from "services/TripadvanceServices";
import { notifyError, notifySuccess } from "utils/toast";

const useTripadvanceSubmit = (id,interiorUrlimage1,  interiorUrlimage2,exteriorUrlimage1, exteriorUrlimage2) => {
 
   
  const { isDrawerOpen, closeDrawer, setIsUpdate } =
    useContext(SidebarContext);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const [selectedReferenceNo,setselectedReferenceNo]=useState('');
  const [exteriorUrl1, setExteriorUrl1] = useState('');
  const [exteriorUrl2, setExteriorUrl2] = useState('');
  const [interiorUrl2, setInteriorUrl2] = useState('');
  const [interiorUrl1, setInteriorUrl1] = useState('');
  const [loading, setLoading] = useState(false);
  const {
    register,
    handleSubmit,
    setValue,
    clearErrors,
    formState: { errors },
  } = useForm();
//console.log('sugaCCCCnya');
  const onSubmit = async (data) => {
    setLoading(true);
   // console.log('suganya arun',data);
    try {
      setIsSubmitting(true);
      if (!interiorUrlimage1 && !interiorUrl1) {
        notifyError("Interior 1 is required.");
        setIsSubmitting(false);
        return;  
      }
   

       if (!interiorUrlimage2 && !interiorUrl2) {
        notifyError("Interior 2 is required.");
        setIsSubmitting(false);
        return;  
      }
      if (!exteriorUrlimage1 && !exteriorUrl1) {
        notifyError("Exterior 1 is required.");
        setIsSubmitting(false);
        return;  
      }
      if (!exteriorUrlimage2 && !exteriorUrl2) {
        notifyError("Exterior 2 is required.");
        setIsSubmitting(false);
        return;  
      }
     // console.log("TripadvanceData:", TripadvanceData);
      const TripadvanceData = {
        vendor_id:selectedReferenceNo,
        tripadvance_name_id:data.tripadvance_name_id,
        tripadvance_reg_no:data.tripadvance_reg_no,
        interior_img_1:interiorUrlimage1||interiorUrl1,
        interior_img_2:interiorUrlimage2||interiorUrl2,
        exterior_img_1:exteriorUrlimage1||exteriorUrl1,
        exterior_img_2:exteriorUrlimage2||exteriorUrl2,
       
        year_of_tripadvance_manufactured: data.year_of_tripadvance_manufactured
      };

      if (id) {
        const res = await TripadvanceServices.updateTripadvance(id, TripadvanceData);
        
        setIsUpdate(true);
        setIsSubmitting(false);
        notifySuccess(res.message);
        closeDrawer();
      } else {
        const res = await TripadvanceServices.addTripadvance( TripadvanceData );
 

        setIsUpdate(true);
        setIsSubmitting(false);
        notifySuccess(res.message);
        closeDrawer();
      }
    //   console.log(res);
    } catch (err) {
      notifyError(err ? err?.response?.data?.message : err?.message);
      setIsSubmitting(false);
    //  closeDrawer();
    }
    finally{
      setLoading(false);
    }
  };
 // console.log(res);
  const getTripadvanceData = async () => {

    try {
      const res = await TripadvanceServices.getTripadvanceById(id);
      if (res) {
        setselectedReferenceNo(String(res.data.vendor_id));

        setValue("year_of_tripadvance_manufactured", res.data.year_of_tripadvance_manufactured);
        setValue("tripadvance_name_id", res.data.tripadvance_name_id);
        setValue("tripadvance_reg_no",res.data.tripadvance_reg_no);
        setExteriorUrl1(res.data.exterior_img_1);
        setExteriorUrl2(res.data.exterior_img_2);
        setInteriorUrl1(res.data.interior_img_1);
        setInteriorUrl1(res.data.interior_img_2);
        
      }
    } catch (err) {
      notifyError(err ? err?.response?.data?.message : err?.message);
    }
  
  };

  useEffect(() => {
    if (!isDrawerOpen) {
      setValue("vendor_id");
      setValue("tripadvance_name_id");
      setValue("tripadvance_reg_no");
      setValue("year_of_tripadvance_manufactured");
      setExteriorUrl1('');
      setExteriorUrl2('');
      setInteriorUrl1('');
      setInteriorUrl2('');
   
      setselectedReferenceNo('');
      clearErrors();
      return;
    }
      
    if (id) {
      getTripadvanceData();
    }
    // eslint-disable-next-line
  }, [id, setValue, isDrawerOpen, clearErrors]);


  return {
    register,
    handleSubmit,
    onSubmit,
    errors,
    isSubmitting,loading,setLoading,
    selectedReferenceNo,setselectedReferenceNo,
    interiorUrl1, setInteriorUrl1,interiorUrl2, setInteriorUrl2,exteriorUrl1, setExteriorUrl1,exteriorUrl2, setExteriorUrl2
  };
};  

export default useTripadvanceSubmit;
